import { Injectable } from '@angular/core';
import packagejson from '../../../package.json';
import buildTime from '@assets/buildTime.json';

@Injectable({
	providedIn: 'root',
})
export class Tools {

	public isIE: boolean = window.navigator.userAgent.indexOf('MSIE ') > -1 ||
		window.navigator.userAgent.indexOf('Trident/') > -1;

	parseHttpError(e: any) {
		if (e && e.error && e.error.statusCode && e.error.message) {
			return ' (' + e.error.statusCode + ': ' + e.error.message + ')';
		}
		return '';
	}

	public getVersion(): string {
		return packagejson.version;
	}

	public getDeploymentTime(): string {
		var nr = buildTime.buildTime;
		if (isNaN(nr)) {
			nr = 42;
		}
		if (nr <= 10000000000) {
			nr = nr * 1000;
		}
		var d = new Date(nr);
		return ('0' + d.getDate()).slice(-2) + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + d.getFullYear() + ' ' + ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2);
	}

	private resizeImage(img, max) {
		var oc = document.createElement('canvas'),
			octx = oc.getContext('2d');
		oc.width = img.width;
		oc.height = img.height;
		octx.drawImage(img, 0, 0);
		if (img.width > img.height) {
			oc.height = (img.height / img.width) * max;
			oc.width = max;
		} else {
			oc.width = (img.width / img.height) * max;
			oc.height = max;
		}
		octx.drawImage(oc, 0, 0, oc.width, oc.height);
		octx.drawImage(img, 0, 0, oc.width, oc.height);
		return oc.toDataURL('image/jpeg', 0.8);
	}

	public createThumbnails(imgB64: string, max: number[] = [350]): Promise<string[]> {
		return new Promise((resolve, reject) => {
			var img: HTMLImageElement = new Image();
			img.onload = () => {
				var ret = [];
				max.forEach(maxValue => {
					ret.push(this.resizeImage(img, maxValue));
				});
				resolve(ret);
			};
			img.src = imgB64;
		});
	}
}

export function loadImage(input): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(input);
		reader.onload = _event => {
			resolve(reader.result + '');
		};
	});
}

export async function getBase64FromUrl(url) {
	const data = await fetch(url);
	const blob = await data.blob();
	return new Promise((resolve) => {
		const reader = new FileReader();
		reader.readAsDataURL(blob);
		reader.onloadend = () => {
			const base64data = reader.result;
			resolve(base64data);
		};
	});
}

export function isObject(value: any): value is object {
	return typeof value === 'object' && value !== null;
}
